







































import _ from 'lodash'
import { Component, Mixins } from 'vue-property-decorator'
import Getsudo from '@/tcw/domain/Getsudo'
import { ApiGeneralSinglePayload } from '@/tcw/api/types'
import BasePage from '@/tcw/components/BasePage'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import TeishutsuInputForm from '@/components/shounin/organisms/TeishutsuInputForm.vue'
import TeishutsuBrowse from '@/components/shounin/organisms/TeishutsuBrowse.vue'
import ShouninRouteSteps from '@/components/settei/organisms/ShouninRouteSteps.vue'
import ShouninRireki from '@/components/shounin/organisms/ShouninRireki.vue'

/**
 * 先月分の勤怠提出情報を表示する。
 *
 */
@Component({
  components: {
    TcwLayoutBasicTemplate,
    TeishutsuInputForm,
    TeishutsuBrowse,
    ShouninRouteSteps,
    ShouninRireki
  }
})
export default class LastTeishutsuPage extends Mixins(BasePage) {
  private activeStep = -1

  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  get lastGetsudo(): Getsudo {
    return Getsudo.last(this.shimebi)
  }

  get teishutsu(): ApiGeneralSinglePayload {
    return this.form?.storeModule?.editData
  }

  get genzaiLevel(): number | null {
    return this.teishutsu?.genzaiLevel as number
  }

  protected checkKintaiList(): void {
    this.$tcw.$store.basic.setTargetDate(this.lastGetsudo.getDate())
    this.goto(`/kintai/list`)
  }

  protected gotoCreatePage(): void {
    this.goto(`/teishutsu/${this.lastGetsudo}`)
  }

  protected action(): void {
    this.goto(`/shounin/${this.lastGetsudo}`)
  }

  protected loaded(teishutsu: ApiGeneralSinglePayload): void {
    // 承認ルートの現在のステップ表示を更新
    const step = new Number(teishutsu.genzaiLevel)
    const maxLevel = new Number(teishutsu.maxLevel)
    if (!_.isNaN(step) && !_.isNaN(maxLevel)) {
      // 現在の承認レベルが最大承認レベルの場合、「完了」にもチェックマークをつけたいので、+1して「完了」のステップが終わったことにする
      this.activeStep = !this.isMaxLevel(step as number, maxLevel as number)
        ? (step as number)
        : (step as number) + 1
    }
  }

  /**
   * 現在の承認レベルが最大承認レベルか判定する
   */
  private isMaxLevel(genzaiLevel: number, maxLevel: number): boolean {
    return _.isEqual(genzaiLevel, maxLevel)
  }
}
